import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import ContactUs from "../views/ContactUs.vue";
import ServicesAreas from "../views/ServicesAreas.vue";
import services from "../views/services/index.vue";
import ServiceSlug from "../views/services/[slug].vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "NextGen Garage Door Repairs in Englewood, NJ | Fast Service",
      description:
        "Trusted garage door repair, installation, and maintenance in Englewood and nearby NJ towns. Call our local experts today for fast, reliable service.",
      canonical: "https://garagerepairenglewood.com",
      keywords:
        "garage door repair, Englewood NJ, garage door installation, garage door maintenance, emergency garage repair",
    },
  },
  {
    path: "/about",
    name: "About",
    component: About,
    meta: {
      title: "About NextGen Garage Door Repairs | Experienced NJ Technicians",
      description:
        "Learn about NextGen Garage Door Repairs – trusted for over 15 years in Englewood, Bergenfield, Tenafly, and nearby areas with expert garage door repair services.",
      canonical: "https://garagerepairenglewood.com",
      keywords:
        "about NextGen Garage, garage repair experts, licensed garage technicians, New Jersey garage services, Englewood garage company",
    },
  },
  {
    path: "/contact",
    name: "ContactUs",
    component: ContactUs,
    meta: {
      title: "Contact NextGen Garage Door Repairs | Schedule Service Today",
      description:
        "Get fast, reliable garage door repair in Englewood, NJ. We specialize in installations, opener repair, new doors, and expert maintenance services.",
      canonical: "https://garagerepairenglewood.com",
      keywords:
        "contact garage repair, schedule garage service, garage door installation, garage door repair near me, Englewood garage service",
    },
  },
  {
    path: "/services/:slug",
    name: "service-slug",
    component: ServiceSlug,
    props: true, // This passes the slug as a prop to the component

    meta: {
      title: "Garage Door Service | NextGen Garage NJ",
      description:
        "Expert garage door repair and maintenance services in New Jersey. From spring replacement to opener fixes, we provide tailored solutions to keep your door running smoothly.",
      canonical: "https://garagerepairenglewood.com",
      keywords:
        "garage door service NJ, spring repair, opener repair, maintenance",
    },
  },
  {
    path: "/services",
    name: "service",
    component: services,
    props: true,

    meta: {
      title: "Services | Garage Door Repair NJ",
      description:
        "Professional garage door services across NJ, including installations, repairs, cable replacement, and expert troubleshooting. Reliable, fast, and affordable help.",
      canonical: "https://garagerepairenglewood.com",
      keywords:
        "garage services NJ, installations, opener repair, cable replacement",
    },
  },
  {
    path: "/service-areas",
    name: "ServicesAreas",
    component: ServicesAreas,
    meta: {
      title: "Service Areas | NextGen Garage NJ",
      description:
        "Expert garage door repair and installation in Englewood, Bergenfield, Tenafly, Fort Lee, and nearby NJ towns. Trusted local specialists for reliable, fast service.",
      canonical: "https://garagerepairenglewood.com",
      keywords:
        "garage repair Englewood, garage installation Bergenfield, garage service Tenafly, Fort Lee garage repair",
    },
  },
  {
    path: "/service-areas/:dynamicArea",
    name: "AreaServices",
    component: services,
    meta: {
      title: "Garage Door Repair Near You | NextGen Garage NJ",
      description:
        "Local garage door repair and installation services available in your area of New Jersey.",
      canonical: "https://garagerepairenglewood.com",
      keywords:
        "local garage repair NJ, garage service near me, opener repair, spring replacement",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
        offset: { x: 0, y: 80 },
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.afterEach((to) => {
  setTimeout(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, 100);

  const defaultTitle = "NextGen Garage Door Repairs | Englewood NJ";
  const defaultDescription =
    "Local, reliable garage door repair, installation, and maintenance in Englewood, NJ.";

  document.title = (to.meta && to.meta.title) || defaultTitle;

  const descriptionTag = document.querySelector('meta[name="description"]');
  if (descriptionTag) {
    descriptionTag.setAttribute(
      "content",
      (to.meta && to.meta.description) || defaultDescription
    );
  } else {
    const meta = document.createElement("meta");
    meta.name = "description";
    meta.content = (to.meta && to.meta.description) || defaultDescription;
    document.head.appendChild(meta);
  }

  const canonicalHref = (to.meta && to.meta.canonical) || null;
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  if (canonicalHref) {
    canonical.setAttribute("href", canonicalHref);
  } else {
    canonical.removeAttribute("href");
  }

  const keywordsContent = (to.meta && to.meta.keywords) || null;
  let keywordsTag = document.querySelector('meta[name="keywords"]');
  if (!keywordsTag) {
    keywordsTag = document.createElement("meta");
    keywordsTag.setAttribute("name", "keywords");
    document.head.appendChild(keywordsTag);
  }
  if (keywordsContent) {
    keywordsTag.setAttribute("content", keywordsContent);
  } else {
    keywordsTag.removeAttribute("content");
  }
});

export default router;
